<template>
  <section
    id="OnlineChatPage"
  >
    <div>
      <breadcrumb-mobile
        ref="header"
        @on-change-page="changePage"
      />
    </div>
    <b-card
      style="background-color: unset !important;"
      :dir="$functions.currentLangDirection()"
    >
      <!-- پشتیبانیِ چهارراه (چتِ آنلاین با دستیار و کارشناس + تیکت‌ها) از 4-rah.com؛ جای گفتینو -->
      <iframe
        ref="support"
        :src="supportUrl"
        title="پشتیبانی چهارراه"
        width="100%"
        height="600"
        frameborder="0"
        style="border: none;"
        allow="microphone"
      />
    </b-card>
  </section>
</template>

<script>

import {
  BCard,
} from 'bootstrap-vue'
import BreadcrumbMobile from '@/layouts/breadcrumb.vue'
// eslint-disable-next-line import/no-cycle
import router from '@/router'

// صفحه‌ی 4-rah.com/support/embed وقتی آماده شد «4rah-support-ready» می‌فرستد؛ توکنِ همین پنل را فقط به همان دامنه
// پس می‌دهیم تا مشتری بدونِ کدِ پیامکیِ دوباره وارد شود. توکن در آدرس نمی‌آید.
const SUPPORT_ORIGIN = process.env.VUE_APP_SUPPORT_ORIGIN || 'https://4-rah.com'

export default {
  components: {
    BreadcrumbMobile,
    BCard,
  },
  data() {
    return { supportUrl: `${SUPPORT_ORIGIN}/support/embed` }
  },
  mounted() {
    this.$refs.header.getTitle('پشتیبانی و گفتگوی آنلاین')
    window.addEventListener('message', this.onSupportMessage)
  },
  beforeDestroy() {
    window.removeEventListener('message', this.onSupportMessage)
  },
  methods: {
    changePage() {
      router.replace({ name: 'home' })
    },
    onSupportMessage(event) {
      if (event.origin !== SUPPORT_ORIGIN || !event.data || event.data.type !== '4rah-support-ready') return
      let user = null
      try {
        user = JSON.parse(localStorage.getItem('user')) || JSON.parse(localStorage.getItem('user_first'))
      } catch (e) {
        user = null
      }
      const frame = this.$refs.support
      if (user && user.token && frame && frame.contentWindow) {
        frame.contentWindow.postMessage({ type: '4rah-support-token', token: user.token }, SUPPORT_ORIGIN)
      }
    },
  },
}
</script>

<style>
#OnlineChatPage {
  height: 100%;
}
iframe {
  width: 100%;
  height: calc(100vh - 200px);
  border: none;
}
@media (max-width: 768px) {
  #OnlineChatPage {
    margin: -28px;
  }
  #OnlineChatPage .card {
    height: calc(100vh - 150px);
    top: -53px;
  }
  iframe {
    height: calc(100vh - 250px);
  }
}
@media (min-width: 768px) {
  #OnlineChatPage {
    background-color: #fff !important;
    width: 800px;
    margin: 0 auto;
  }
}
</style>
